import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'safeLink',
    standalone: false
})
export class SafeLinkPipe implements PipeTransform {

  transform(url: string): string {
    if (!url) return '';
    if (!/^https?:\/\//i.test(url)) {
      return 'https://' + url;
    }
    return url;
  }

}
